import { app } from '../../utils/store';

export default class Menu {
    constructor() {
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
            quick: document.querySelector('header .quick-menu'),
            dropdown: document.querySelectorAll('#main-menu .dropdown > .dropdown-link'),
        }

        // this.lang = {
        //     toggler: document.querySelector('#select-language .dropdown-toggler'),
        //     menu: document.querySelector('#select-language .dropdown-menu')
        // }

        this.search = {
            toggler: document.getElementById('search-toggler'),
            main: document.getElementById('search'),
        }

        this.service = {
            toggler: document.querySelector('.quick-menu a[href*="@service-menu"]'),
            menu: document.getElementById('service-menu')
        }

        this.modal = {
            element: document.querySelector('[data-modal]'),
        };

        this.header = document.querySelector('header');
        this.body = document.querySelector('body');
        app.overlay = document.querySelector('.app-overlay');
    }

    init() {
        this.toggle();
        this.dropdown();
        // if(!Sniff.features.mobile){ this.language(); }
    }

    toggle = () => {
        // CLICK on Menu Toggler
        if(this.menu.toggler){
            this.menu.toggler.addEventListener('click', () => {
                if(!this.header.classList.contains('modal-active')){
                    this.menu.main.classList.toggle('active');
                    this.menu.toggler.classList.toggle('active');
                    app.overlay.classList.toggle('active');
                    this.body.classList.toggle('overflow-hidden');
                    this.menu.quick.classList.toggle('disabled');
                    this.search.toggler.classList.toggle('disabled');
                }
                
                // Close Dropdown Menus
                if(this.menu.main.classList.contains('dropdown-active')){
                    this.menu.dropdown.forEach((toggler)=>{
                        toggler.classList.remove('active');
                        toggler.parentNode.classList.remove('active');
                    });
                    this.menu.main.classList.remove('dropdown-active')
                };
            });
        }

        // CLICK on Services Toggler
        if(this.service.toggler){
            this.service.toggler.addEventListener('click', (toggler) => {
                toggler.preventDefault();
                this.service.menu.classList.toggle('active');
                this.service.toggler.classList.toggle('active');
                app.overlay.classList.toggle('active');
                this.body.classList.toggle('overflow-hidden');
                this.menu.quick.classList.toggle('active');
                this.search.toggler.classList.toggle('disabled');
                this.menu.toggler.classList.toggle('disabled');
                if(this.menu.main){
                    this.menu.toggler.classList.remove('active');
                    this.menu.main.classList.remove('active');
                };
            });

            this.service.toggler.addEventListener('contextmenu', (toggler)=>{
                toggler.preventDefault();
                console.log(toggler.which)
                // If click was with 'mousewheel(2)' or 'right-button(3)'
                if(toggler.which === 2 || toggler.which === 3){
                    toggler.target.click();
                }
            })
        }

        app.overlay.addEventListener('click', () => {
            app.overlay.classList.remove('active');
            this.body.classList.remove('overflow-hidden');
            this.menu.toggler.classList.remove('active');
            this.menu.main.classList.remove('active');
            this.service.toggler.classList.remove('active');
            this.service.menu.classList.remove('active');
            this.search.main.classList.remove('active');

            this.menu.quick.classList.remove('active');
            this.search.toggler.classList.remove('active');
            this.menu.quick.classList.remove('disabled');
            this.menu.toggler.classList.remove('disabled');
            this.search.toggler.classList.remove('disabled');
        });
    }

    dropdown = () => {
        if(this.menu.dropdown){
            this.menu.dropdown.forEach((toggler)=>{
                toggler.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.target.parentNode.classList.toggle('active');
                    this.menu.main.classList.toggle('dropdown-active');
                });
            })
        }
    }

    language = () => {
        this.lang.toggler.addEventListener('click', () => {
            this.lang.menu.classList.toggle('show');
        });
    }
}
